export const classes = {
  card: 'place-between pl-4 pr-3 py-3 bg-grey-2 dark:bg-white/[0.06] hover:bg-grey-3 dark:hover:bg-white/[0.1] text-grey-8 dark:text-mauve-1 shadow-none my-2',
  content: 'place-start grow text-left outline-none cursor-pointer',
  preview:
    'size-10 rounded-md object-contain border border-grey-3 dark:border-white/10 bg-white dark:bg-[#332e43] shrink-0',
  title: 'pointer-events-none text-sm',
  details: 'pl-6 pr-4',
  closeIcon: 'close-icon text-grey-8 dark:text-mauve-1 transition-all',
};

export const styles = {
  card: {
    '&:hover .close-icon': {
      opacity: 1,
    },
    '& .close-icon': {
      opacity: 0,
    },
  },
};
